import { CircleFragment } from '@gql'
import React from 'react'
import { CirclePerimeter } from '../circlePerimeter'
import useCirclePerimeterFilter from '../hooks/useCirclePerimeterFilter'
import useCirclePicker from '../hooks/useCirclePicker'
import { useCircleSearchItems } from '../hooks/useCircleSearchItems'
import SearchButton, { SearchButtonProps } from './SearchButton'

interface Props extends Omit<SearchButtonProps, 'items' | 'perimeter'> {
  circles?: CircleFragment[] // If not provided, use store
  excludeIds?: string[]
  // ORG-02: the filter the list opens on. The user can switch it from the bar
  // at the top of the list; in a meeting, the list opens on the meeting's
  // circle instead (#123).
  defaultPerimeter?: CirclePerimeter
}

export default function CircleSearchButton({
  circles,
  excludeIds,
  defaultPerimeter = 'all',
  ...props
}: Props) {
  const items = useCircleSearchItems(circles, excludeIds)
  const { pickerModal, additionalTopItems, handleChange } = useCirclePicker(
    props.onSelect
  )
  const perimeter = useCirclePerimeterFilter(defaultPerimeter)

  return (
    <>
      <SearchButton
        {...props}
        items={items}
        onSelect={handleChange}
        additionalTopItems={additionalTopItems}
        perimeter={perimeter}
      />
      {pickerModal}
    </>
  )
}
